// Header.js
import "./Header.css";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";

import hLines from "../../static/h_lines.png";
import Brand from "../../static/brand.png";

import Indice from "./Indice";
import Usuario from "./Usuario";
import useFetchAppVersion from "../0. Utilidades/useFetchAppVersion"; // Import the custom hook

function Header() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const appVersion = useFetchAppVersion(); // Fetch the app version

  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
  };

  return (
    <div id="Header">
      <div className="header-container">
        <div id="h_left">
          <img
            src={hLines}
            className="b_indice"
            alt="Logo"
            loading="eager"
            onClick={handleOffcanvasToggle}
            style={{ cursor: "pointer" }}
          />
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <img src={Brand} alt="Logo" loading="eager" />
          </Link>
        </div>
        <Usuario />
        <Offcanvas
          show={showOffcanvas}
          onHide={handleOffcanvasToggle}
          placement="start"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              Menu
              <br />
              <div
                style={{
                  fontSize: "10px",
                  fontStyle: "italic",
                  color: "#6c757d",
                }}
              >
                Version: {appVersion} {/* Display app version here */}
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Indice handleOffcanvasToggle={handleOffcanvasToggle} />
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </div>
  );
}

export default Header;
